import { ComponentStyleConfig } from '@chakra-ui/react'
import merge from 'lodash/merge'
import { Divider as base } from './base'

export const Divider: ComponentStyleConfig = merge({}, base, {
  baseStyle: {},
})
